import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom'
import { Button } from "@univdiam/ui/components/button"
import { SubGroupDataTable } from "@univdiam/ui/customComponents/SubGroupList/data-table"
import { groupColumns } from "@univdiam/ui/customComponents/SubGroupList/columns"
import { EditSubGroupForm } from "@univdiam/ui/customComponents/SubGroupList/EditSubGroupForm"

// import api from '@/http/api'
import axios from "axios"

const API_BASE_URL = import.meta.env.VITE_SERVER_URL

export default function SubGroupPage() {
  const [data, setData] = useState([])
  const [editSubGroupData, setEditSubGroupData] = useState(null)

  useEffect(() => {
    axios.get(`${API_BASE_URL}/api/sub_groups`)
      .then(res => {
        const transformed = res.data.data.map((group: any) => ({
          sub_group_id: group.sub_group_id.toString(),
          group_id: group.group_id.toString(),
          name: group.name,
          code: group.code || "",
          status: group.status === 1 ? "Enabled" : "Disabled"
        }))
        setData(transformed)
      })
      .catch(err => console.error("Failed to fetch sub_groups", err))
  }, [])

  const handleDelete = async (id: string) => {
    console.log(id)
    const confirm = window.confirm("Are you sure you want to delete this group?")
    if (!confirm) return

    try {
      const res = await axios.delete(`${API_BASE_URL}/api/sub_groups/${id}`)
      if (res.status === 200) {
        alert("SubGroup deleted successfully.")
        // setData(prev => prev.filter(group => group.group_id !== id))
      } else {
        alert("Failed to delete group.")
      }
    } catch (error) {
      console.error("Delete error:", error)
      alert("Something went wrong.")
    }
  }

  const handleEdit = async (id: string) => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/sub_groups/${id}`)
      if (res.status === 200) {
        setEditSubGroupData(res.data)
        // setData(prev => prev.filter(group => group.group_id !== id))
      } else {
        alert("Failed to fetch group.")
      }
    } catch (error) {
      console.error("Delete error:", error)
      alert("Something went wrong.")
    }
  }

  const navigate = useNavigate()

  const handleAddSubGroup = () => {
    navigate("/sub-group/add")
  }

  const columns = groupColumns({ onEdit: handleEdit, onDelete: handleDelete })

  return (
    <div className="p-5">
      <div className="flex justify-between mb-4">
        <h1 className="text-xl font-semibold">Sub Group Management</h1>
        {/* <Button onClick={() => setCreateSubGroup(true)}>+ Add Sub Group</Button> */}
        <div className="flex justify-end mb-4">
          <Button onClick={handleAddSubGroup}>+ Add Sub Group</Button>
        </div>
      </div>
      <SubGroupDataTable columns={columns} data={data} />
      {editSubGroupData && (
        <EditSubGroupForm
          group={editSubGroupData}
          onCancel={() => setEditSubGroupData(null)}
          onSave={() => {
            setEditSubGroupData(null)
            fetchSubGroups() // refresh table
          }}
        />
      )}
    </div>
  )
}
